import React from 'react';

import Icon from '../Icon';

const FeatureIcon = ({isActive, ...rest}) => {
    return (
        <Icon width='25' height='24' viewBox='0 0 25 24' fill='none' {...rest}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.1667 2C12.6419 2 13.1161 2.16149 13.5107 2.48446L19.3289 7.24782C19.5898 7.46152 19.8009 7.73463 19.946 8.04645C20.0912 8.35827 20.1667 8.70062 20.1667 9.04753V19.7148C20.1667 20.3455 19.9224 20.9173 19.5277 21.3307C19.1331 21.7441 18.5871 22 17.9849 22H6.34857C6.06199 22.0004 5.77817 21.9415 5.5134 21.8266C5.24864 21.7117 5.00816 21.5432 4.80578 21.3307C4.60288 21.1187 4.44197 20.8668 4.33231 20.5895C4.22264 20.3122 4.16638 20.015 4.16675 19.7148V9.04753C4.16675 8.34471 4.47608 7.68048 5.00457 7.24782L10.8227 2.48446C11.2064 2.1701 11.6796 1.99952 12.1667 2V2Z'
                className={isActive ? 'stroke-color-primary' : 'stroke-color-primary dark:stroke-color-secondary'}
                strokeWidth='1.5'
            />
        </Icon>
    );
};

export default FeatureIcon;
